export function driveImageSize(src, width) {
    if (!src || typeof src !== 'string') {
        return src || '';
    }

    if (!/drive\.google\.com\/thumbnail/i.test(src)) {
        return src;
    }

    try {
        const url = new URL(src);
        url.searchParams.set('sz', `w${width}`);
        return url.toString();
    } catch (error) {
        return src.replace(/([?&]sz=)w?\d+/i, `$1w${width}`);
    }
}

const driveVariantWidth = {
    thumb: 300,
    card: 400,
    large: 800,
};

const productVariantPattern = /-(large|card|thumb)(\.[a-z0-9]+)(?=([?#]|$))/i;

export function productImageVariantUrl(src, variant = 'card') {
    if (!src || typeof src !== 'string') {
        return src || '';
    }

    if (/drive\.google\.com\/thumbnail/i.test(src)) {
        return driveImageSize(src, driveVariantWidth[variant] || driveVariantWidth.card);
    }

    if (!/\/imagenes_productos\//i.test(src) || !productVariantPattern.test(src)) {
        return src;
    }

    return src.replace(productVariantPattern, `-${variant}$2`);
}

export const catalogImageUrl = (src) => productImageVariantUrl(src, 'card');
export const searchImageUrl = (src) => productImageVariantUrl(src, 'thumb');
export const detailImageUrl = (src) => productImageVariantUrl(src, 'large');
export const adminImageUrl = (src) => productImageVariantUrl(src, 'thumb');
